import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { UsersComponent } from './users/users.component';
import { ManagementLayoutComponent } from './management-layout/management-layout.component';
import { AdminGuard } from '../../guards/admin.guard';

const routes:
    Routes = [
        {
            path: '',
            component: ManagementLayoutComponent,
            canActivate: [AdminGuard],
            children: [
                {
                    path: 'users',
                    component: UsersComponent,
                },
            ]
        },
    ];

@NgModule({
    imports: [RouterModule.forChild(routes)],
    exports: [RouterModule],
})
export class ManagementRoutingModule { }
